<div mat-dialog-content>
	<p>
		<span [cmLocalize]="locFeature + '/Error.GUID.ReloadNeeded'">
			There was a problem and a system reload is needed.
		</span>
	</p>
</div>

<div mat-dialog-actions>
	<button mat-dialog-close color="primary">
		<span [cmLocalize]="locFeature + '/_Shared.ReloadConfirmation.Button.Confirm'">
			Reload
		</span>
	</button>
</div>
